export const AUTH = {
  BACK_BUTTON: 'BACK_BUTTON',
  BACK_TO_SIGN_IN_BUTTON: 'BACK_TO_SIGN_IN_BUTTON',
  EMAIL_FIELD_TEXT: 'EMAIL_FIELD_TEXT',
  EMAIL_SIGN_IN_METHOD: 'EMAIL_SIGN_IN_METHOD',
  MOBILE_APP_NOT_INSTALLED_MESSAGE: 'MOBILE_APP_NOT_INSTALLED_MESSAGE',
  MOBILE_BACK_TO_LOGIN: 'MOBILE_BACK_TO_LOGIN',
  MOBILE_GET_APP_FROM_APPLE_STORE: 'MOBILE_GET_APP_FROM_APPLE_STORE',
  MOBILE_GET_APP_FROM_GOOGLE_PLAY_STORE:
    'MOBILE_GET_APP_FROM_GOOGLE_PLAY_STORE',
  NAME_FIELD_LABEL: 'NAME_FIELD_LABEL',
  NOT_SIGNED_IN_TOOLTIP: 'NOT_SIGNED_IN_TOOLTIP',
  PASSWORD_FIELD_LABEL: 'PASSWORD_FIELD_LABEL',
  PASSWORD_SIGN_IN_METHOD: 'PASSWORD_SIGN_IN_METHOD',
  RESEND_EMAIL_BUTTON: 'RESEND_EMAIL_BUTTON',
  SIGN_IN_BUTTON: 'SIGN_IN_BUTTON',
  SIGN_IN_PASSWORD_BUTTON: 'SIGN_IN_PASSWORD_BUTTON',
  SIGN_IN_HEADER: 'SIGN_IN_HEADER',
  SIGN_IN_LINK_TEXT: 'SIGN_IN_LINK_TEXT',
  SIGN_IN_LINK_TEXT_BUTTON: 'SIGN_IN_LINK_TEXT_BUTTON',
  SIGN_IN_SUCCESS_EMAIL_PROBLEM: 'SIGN_IN_SUCCESS_EMAIL_PROBLEM',
  SIGN_IN_SUCCESS_TEXT: 'SIGN_IN_SUCCESS_TEXT',
  SIGN_IN_SUCCESS_TITLE: 'SIGN_IN_SUCCESS_TITLE',
  SIGN_UP_BUTTON: 'SIGN_UP_BUTTON',
  SIGN_UP_HEADER: 'SIGN_UP_HEADER',
  SIGN_UP_LINK_TEXT: 'SIGN_UP_LINK_TEXT',
  SIGN_UP_SAVE_ACTIONS_LABEL: 'SIGN_UP_SAVE_ACTIONS_LABEL',
  SIGN_UP_SAVE_ACTIONS_TOOLTIP: 'SIGN_UP_SAVE_ACTIONS_TOOLTIP',
  SIGN_UP_SUCCESS_TITLE: 'SIGN_UP_SUCCESS_TITLE',
  SWITCH_ACCOUNT_TEXT: 'SWITCH_ACCOUNT_TEXT',
  API_UNAVAILABLE_TITLE: 'API_UNAVAILABLE_TITLE',
  API_UNAVAILABLE_EXPLANATION: 'API_UNAVAILABLE_EXPLANATION',
  API_UNAVAILABLE_INSTRUCTIONS: 'API_UNAVAILABLE_INSTRUCTIONS',
  API_UNAVAILABLE_BUTTON: 'API_UNAVAILABLE_BUTTON',
  USER_AGREEMENTS_TERMS_OF_SERVICE: 'USER_AGREEMENTS_TERMS_OF_SERVICE',
  USER_AGREEMENTS_PRIVACY_POLICY: 'USER_AGREEMENTS_PRIVACY_POLICY',
  USER_AGREEMENTS_CHECKBOX_LABEL: 'USER_AGREEMENTS_CHECKBOX_LABEL',
  TERMS_OF_SERVICE_LINK: 'TERMS_OF_SERVICE_LINK',
  PRIVACY_POLICY_LINK: 'PRIVACY_POLICY_LINK',
  INVITATIONS_LOADING_MESSAGE: 'INVITATIONS_LOADING_MESSAGE',
  USERNAME_TOO_SHORT_ERROR: 'USERNAME_TOO_SHORT_ERROR',
  USERNAME_SPECIAL_CHARACTERS_ERROR: 'USERNAME_SPECIAL_CHARACTERS_ERROR',
  USERNAME_TOO_LONG_ERROR: 'USERNAME_TOO_LONG_ERROR',
  INVALID_EMAIL_ERROR: 'INVALID_EMAIL_ERROR',
  EMPTY_EMAIL_ERROR: 'EMPTY_EMAIL_ERROR',
  REQUIRED_FIELD_ERROR: 'REQUIRED_FIELD_ERROR',
  PASSWORD_EMPTY_ERROR: 'PASSWORD_EMPTY_ERROR',
  PASSWORD_WEAK_ERROR: 'PASSWORD_WEAK_ERROR',
  PASSWORD_DO_NOT_MATCH_ERROR: 'PASSWORD_DO_NOT_MATCH_ERROR',
  PASSWORD_SUCCESS_ALERT: 'PASSWORD_SUCCESS_ALERT',
  EMAIL_INPUT_PLACEHOLDER: 'EMAIL_INPUT_PLACEHOLDER',
  PASSWORD_INPUT_PLACEHOLDER: 'PASSWORD_INPUT_PLACEHOLDER',
  BUILDER_BACKGROUND_TEXT: 'BUILDER_BACKGROUND_TEXT',
  PLAYER_BACKGROUND_TEXT: 'PLAYER_BACKGROUND_TEXT',
  LIBRARY_BACKGROUND_TEXT: 'LIBRARY_BACKGROUND_TEXT',
  ANALYTICS_BACKGROUND_TEXT: 'ANALYTICS_BACKGROUND_TEXT',
  BUILDER_BACKGROUND_TEXT_PLATFORM: 'BUILDER_BACKGROUND_TEXT_PLATFORM',
  PLAYER_BACKGROUND_TEXT_PLATFORM: 'PLAYER_BACKGROUND_TEXT_PLATFORM',
  LIBRARY_BACKGROUND_TEXT_PLATFORM: 'LIBRARY_BACKGROUND_TEXT_PLATFORM',
  ANALYTICS_BACKGROUND_TEXT_PLATFORM: 'ANALYTICS_BACKGROUND_TEXT_PLATFORM',
  REQUEST_PASSWORD_RESET_LINK: 'REQUEST_PASSWORD_RESET_LINK',
  REQUEST_PASSWORD_RESET_TITLE: 'REQUEST_PASSWORD_RESET_TITLE',
  REQUEST_PASSWORD_RESET_TEXT: 'REQUEST_PASSWORD_RESET_TEXT',
  REQUEST_PASSWORD_RESET_BUTTON: 'REQUEST_PASSWORD_RESET_BUTTON',
  REQUEST_PASSWORD_RESET_BACK_BUTTON: 'REQUEST_PASSWORD_RESET_BACK_BUTTON',
  REQUEST_PASSWORD_RESET_UPDATE_TITLE: 'REQUEST_PASSWORD_RESET_UPDATE_TITLE',
  REQUEST_PASSWORD_RESET_CONFIRM_PASSWORD_TITLE:
    'REQUEST_PASSWORD_RESET_CONFIRM_PASSWORD_TITLE',
  REQUEST_PASSWORD_RESET_SUCCESS_MESSAGE:
    'REQUEST_PASSWORD_RESET_SUCCESS_MESSAGE',
  REQUEST_PASSWORD_RESET_ERROR_MESSAGE: 'REQUEST_PASSWORD_RESET_ERROR_MESSAGE',
  RESET_PASSWORD_TITLE: 'RESET_PASSWORD_TITLE',
  RESET_PASSWORD_DESCRIPTION: 'RESET_PASSWORD_DESCRIPTION',
  RESET_PASSWORD_NEW_PASSWORD_FIELD_LABEL:
    'RESET_PASSWORD_NEW_PASSWORD_FIELD_LABEL',
  RESET_PASSWORD_NEW_PASSWORD_CONFIRMATION_FIELD_LABEL:
    'RESET_PASSWORD_NEW_PASSWORD_CONFIRMATION_FIELD_LABEL',
  RESET_PASSWORD_BUTTON: 'RESET_PASSWORD_BUTTON',
  RESET_PASSWORD_MISSING_TOKEN: 'RESET_PASSWORD_MISSING_TOKEN',
  RESET_PASSWORD_SUCCESS_MESSAGE: 'RESET_PASSWORD_SUCCESS_MESSAGE',
  RESET_PASSWORD_ERROR_MESSAGE: 'RESET_PASSWORD_ERROR_MESSAGE',
  RESET_PASSWORD_ERROR_TRY_AGAIN: 'RESET_PASSWORD_ERROR_TRY_AGAIN',
  RESET_PASSWORD_REQUIREMENTS_TITLE: 'RESET_PASSWORD_REQUIREMENTS_TITLE',
  RESET_PASSWORD_REQUIREMENTS_LENGTH: 'RESET_PASSWORD_REQUIREMENTS_LENGTH',
  RESET_PASSWORD_REQUIREMENTS_LOWERCASE:
    'RESET_PASSWORD_REQUIREMENTS_LOWERCASE',
  RESET_PASSWORD_REQUIREMENTS_UPPERCASE:
    'RESET_PASSWORD_REQUIREMENTS_UPPERCASE',
  RESET_PASSWORD_REQUIREMENTS_NUMBER: 'RESET_PASSWORD_REQUIREMENTS_NUMBER',
  LOGIN_METHODS_DIVIDER: 'LOGIN_METHODS_DIVIDER',
  SHOW_PASSWORD: 'SHOW_PASSWORD',
  INVALID_TOKEN_PROVIDED_TITLE: 'INVALID_TOKEN_PROVIDED_TITLE',
  INVALID_TOKEN_PROVIDED_DESCRIPTION: 'INVALID_TOKEN_PROVIDED_DESCRIPTION',
  REDIRECTION_TITLE: 'REDIRECTION_TITLE',
  REDIRECTION_DESCRIPTION: 'REDIRECTION_DESCRIPTION',
  REDIRECTION_BUTTON: 'REDIRECTION_BUTTON',
};
